import React, { useState, useEffect } from 'react';

const DEFAULT_PLACEHOLDER = '/images/admin/course/course1.png';

/**
 * Course thumbnail component.
 */
function CourseThumbnail({ src, alt = 'Course', className = '', fallback = DEFAULT_PLACEHOLDER }) {
  const [error, setError] = useState(false);
  const imageUrl = error || !src ? fallback : src;

  useEffect(() => {
    setError(false);
  }, [src]);

  return (
    <div
      className={`relative flex-shrink-0 rounded-lg border border-gray-200 overflow-hidden bg-gray-100 ${className}`}
      style={{ width: '160px', height: '90px' }}
    >
      <img
        src={imageUrl}
        alt={alt}
        className="rounded-lg border-0 w-full h-full object-cover"
        style={{
          width: '160px',
          height: '90px',
        }}
        onError={() => setError(true)}
      />
    </div>
  );
}

export default CourseThumbnail;
